"use client"

import { useEffect } from "react"
import { ErrorState } from "@/components/error-state"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <html lang="pt-BR">
      <body>
        <ErrorState
          code="Ops"
          eyebrow="Falha inesperada"
          title="A operação saiu da rota por um instante"
          description="O aplicativo encontrou um problema inesperado. Tente recarregar; se ele continuar, volte ao início e entre novamente."
          imageSrc="/illustrations/error-unexpected.png"
          imageAlt="Profissional realizando uma manutenção tranquila em um equipamento"
          onRetry={reset}
        />
      </body>
    </html>
  )
}
